import { Injectable, EventEmitter } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountryISO } from 'ngx-intl-tel-input';

@Injectable()
export class Helper {
  public sanitizer;
  public popupResponse$ = new EventEmitter();


  public constructor(
    sanitizer: DomSanitizer,
    private readonly modalService: NgbModal
  ) {
    this.sanitizer = sanitizer;
  }

  //   public goToLink(urlPath: string): void {
  //     let url = '';
  //     if (!/^http[s]?:\/\//.test(urlPath)) {
  //       url += 'http://';
  //     }

  //     url += urlPath;
  //     window.open(url, '_blank');
  //   }

  //   public safeUrlLink(url): SafeResourceUrl {
  //     if (url) {
  //       return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  //     }
  //   }

  //   public pluckListColumn(list, propertyName): void {
  //     return list.map(i => {
  //       return i[propertyName];
  //     });
  //   }
  public static escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  public deepCopy(obj: any) {

    var clonedObject: any;

    if (obj instanceof Array) {
      var itemArray = Object.assign([], obj);
      clonedObject = itemArray;

      for (var j = 0; j < clonedObject.length; j++) {
        clonedObject[j] = this.deepCopy(clonedObject[j]);
      }

      return clonedObject;
    }
    else if (typeof obj === 'number' || typeof obj == 'string') {
      return obj
    }
    else {


      var item = Object.assign({}, obj);
      clonedObject = item;

      let allKeys = Object.keys(clonedObject);

      for (var i = 0; i < allKeys.length; i++) {
        if (clonedObject[allKeys[i]] instanceof Array) {
          //If the calue is Array
          clonedObject[allKeys[i]] = this.deepCopy(clonedObject[allKeys[i]]);
        }
        else if (clonedObject[allKeys[i]] instanceof Date) {
          clonedObject[allKeys[i]] = new Date(clonedObject[allKeys[i]].valueOf());
        }
        else if (clonedObject[allKeys[i]] instanceof Object) {
          //if the value is JOBJECT.
          clonedObject[allKeys[i]] = this.deepCopy(clonedObject[allKeys[i]]);
        }
      }
      return clonedObject;
    }


  }
  public openPopupService(
    popupOptions: any,
    componentFile: any,
    data: any = null
  ): void {
    const modalRef = this.modalService.open(componentFile, popupOptions);
    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        this.popupResponse$.emit(result);
      },
      (reason) => {
        this.popupResponse$.emit(this.getDismissReason(reason));
      }
    );
  }

  public getStickHeadersHeight(): number {
    let totalHeight = 0;
    const headers = document.getElementsByClassName('sticky-header');
    if (headers && headers.length > 0) {
      for (let i = 0; i < headers.length; i++) {
        const header = headers[i] as HTMLElement;
        totalHeight += header.offsetHeight;
      }
    }
    return totalHeight;
  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return reason;
    }
  }
  public groupBy(items: any, key: string): any {
    const result = items.reduce(
      (result: any, item: any) => ({
        ...result,
        [item[key]]: [
          ...(result[item[key]] || []),
          item,
        ],
      }),
      {},
    );
    return result;
  }
  //   public downloadFile(data, filename = 'data'): void {
  //     const blob = new Blob(['\ufeff' + data], {
  //       type: 'text/csv;charset=utf-8;'
  //     });
  //     const dwldLink = document.createElement('a');
  //     const url = URL.createObjectURL(blob);
  //     const isSafariBrowser =
  //       navigator.userAgent.indexOf('Safari') !== -1 &&
  //       navigator.userAgent.indexOf('Chrome') === -1;
  //     // if Safari open in new window to save file with random filename.
  //     if (isSafariBrowser) {
  //       dwldLink.setAttribute('target', '_blank');
  //     }
  //     dwldLink.setAttribute('href', url);
  //     dwldLink.setAttribute('download', filename + '.csv');
  //     dwldLink.style.visibility = 'hidden';
  //     document.body.appendChild(dwldLink);
  //     dwldLink.click();
  //     document.body.removeChild(dwldLink);
  //   }

  //   public dataURItoBlob(dataURI): BlobPart {
  //     // convert base64/URLEncoded data component to raw binary data held in a string
  //     let byteString;
  //     if (dataURI.split(',')[0].indexOf('base64') >= 0) {
  //       byteString = atob(dataURI.split(',')[1]);
  //     } else {
  //       byteString = unescape(dataURI.split(',')[1]);
  //     }

  //     // separate out the mime component
  //     const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  //     // write the bytes of the string to a typed array
  //     const ia = new Uint8Array(byteString.length);
  //     for (let i = 0; i < byteString.length; i++) {
  //       ia[i] = byteString.charCodeAt(i);
  //     }

  //     return new Blob([ia], { type: mimeString });
  //   }

  //   public getTextEditorConfig(): {} {
  //     return {
  //       editable: true,
  //       spellcheck: true,
  //       height: '15rem',
  //       minHeight: '5rem',
  //       maxHeight: 'auto',
  //       width: 'auto',
  //       minWidth: '0',
  //       translate: 'yes',
  //       enableToolbar: true,
  //       showToolbar: true,
  //       placeholder: 'Enter text here...',
  //       defaultParagraphSeparator: '',
  //       defaultFontName: '',
  //       defaultFontSize: '',
  //       fonts: [
  //         { class: 'arial', name: 'Arial' },
  //         { class: 'times-new-roman', name: 'Times New Roman' },
  //         { class: 'calibri', name: 'Calibri' },
  //         { class: 'comic-sans-ms', name: 'Comic Sans MS' }
  //       ],
  //       customClasses: [
  //         {
  //           name: 'quote',
  //           class: 'quote'
  //         },
  //         {
  //           name: 'redText',
  //           class: 'redText'
  //         },
  //         {
  //           name: 'titleText',
  //           class: 'titleText',
  //           tag: 'h1'
  //         }
  //       ],
  //       uploadUrl: 'v1/image',
  //       uploadWithCredentials: false,
  //       sanitize: true,
  //       toolbarPosition: 'top',
  //       toolbarHiddenButtons: [
  //         ['fontName'],
  //         [
  //           'insertImage',
  //           'insertVideo',
  //           'textColor',
  //           'backgroundColor',
  //           'customClasses'
  //         ]
  //       ]
  //     };
  //   }

  //   public getCountryPhoneCodes(): string[] {
  //     return [
  //       '+1',
  //       '+7',
  //       '+20',
  //       '+27',
  //       '+30',
  //       '+31',
  //       '+32',
  //       '+33',
  //       '+34',
  //       '+36',
  //       '+39',
  //       '+40',
  //       '+41',
  //       '+43',
  //       '+44',
  //       '+45',
  //       '+46',
  //       '+47',
  //       '+48',
  //       '+49',
  //       '+51',
  //       '+52',
  //       '+53',
  //       '+54',
  //       '+55',
  //       '+56',
  //       '+57',
  //       '+58',
  //       '+60',
  //       '+61',
  //       '+62',
  //       '+63',
  //       '+64',
  //       '+65',
  //       '+66',
  //       '+81',
  //       '+82',
  //       '+84',
  //       '+86',
  //       '+90',
  //       '+91',
  //       '+92',
  //       '+93',
  //       '+94',
  //       '+95',
  //       '+98',
  //       '+211',
  //       '+212',
  //       '+212',
  //       '+213',
  //       '+216',
  //       '+218',
  //       '+220',
  //       '+221',
  //       '+222',
  //       '+223',
  //       '+224',
  //       '+225',
  //       '+226',
  //       '+227',
  //       '+228',
  //       '+229',
  //       '+230',
  //       '+231',
  //       '+232',
  //       '+233',
  //       '+234',
  //       '+235',
  //       '+236',
  //       '+237',
  //       '+238',
  //       '+239',
  //       '+240',
  //       '+241',
  //       '+242',
  //       '+243',
  //       '+244',
  //       '+245',
  //       '+246',
  //       '+248',
  //       '+249',
  //       '+250',
  //       '+251',
  //       '+252',
  //       '+253',
  //       '+254',
  //       '+255',
  //       '+256',
  //       '+257',
  //       '+258',
  //       '+260',
  //       '+261',
  //       '+262',
  //       '+263',
  //       '+264',
  //       '+265',
  //       '+266',
  //       '+267',
  //       '+268',
  //       '+269',
  //       '+290',
  //       '+291',
  //       '+297',
  //       '+298',
  //       '+299',
  //       '+350',
  //       '+351',
  //       '+352',
  //       '+353',
  //       '+354',
  //       '+355',
  //       '+356',
  //       '+357',
  //       '+358',
  //       '+359',
  //       '+370',
  //       '+371',
  //       '+372',
  //       '+373',
  //       '+374',
  //       '+375',
  //       '+376',
  //       '+377',
  //       '+378',
  //       '+379',
  //       '+380',
  //       '+381',
  //       '+382',
  //       '+383',
  //       '+385',
  //       '+386',
  //       '+387',
  //       '+389',
  //       '+420',
  //       '+421',
  //       '+423',
  //       '+500',
  //       '+501',
  //       '+502',
  //       '+503',
  //       '+504',
  //       '+505',
  //       '+506',
  //       '+507',
  //       '+508',
  //       '+509',
  //       '+590',
  //       '+591',
  //       '+592',
  //       '+593',
  //       '+594',
  //       '+595',
  //       '+596',
  //       '+597',
  //       '+598',
  //       '+599',
  //       '+599',
  //       '+599',
  //       '+670',
  //       '+672',
  //       '+673',
  //       '+674',
  //       '+675',
  //       '+676',
  //       '+677',
  //       '+678',
  //       '+679',
  //       '+680',
  //       '+681',
  //       '+682',
  //       '+683',
  //       '+685',
  //       '+686',
  //       '+687',
  //       '+688',
  //       '+689',
  //       '+690',
  //       '+691',
  //       '+692',
  //       '+850',
  //       '+852',
  //       '+853',
  //       '+855',
  //       '+856',
  //       '+870',
  //       '+880',
  //       '+886',
  //       '+960',
  //       '+961',
  //       '+962',
  //       '+963',
  //       '+964',
  //       '+965',
  //       '+966',
  //       '+967',
  //       '+968',
  //       '+970',
  //       '+971',
  //       '+972',
  //       '+973',
  //       '+974',
  //       '+975',
  //       '+976',
  //       '+977',
  //       '+992',
  //       '+993',
  //       '+994',
  //       '+995',
  //       '+996',
  //       '+998',
  //       '+1-246',
  //       '+1-441',
  //       '+1-876',
  //       '+1-242',
  //       '+1-671',
  //       '+1-473',
  //       '+1-787',
  //       '+1-684',
  //       '+1-264',
  //       '+1-340',
  //       '+1-268',
  //       '+1-784',
  //       '+1-649',
  //       '+1-868',
  //       '+1-758',
  //       '+1-284',
  //       '+1-809',
  //       '+1-767',
  //       '+1-345',
  //       '+1-869',
  //       '+1-670',
  //       '+1-664',
  //       '+358-18',
  //       '+44-1481',
  //       '+44-1534',
  //       '+44-1624'
  //     ];
  //   }
}
